module.exports = __webpack_public_path__ + "static/fonts/materialdesign-icons.cdf5969.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/materialdesign-icons.woff2
// module id = 1055
// module chunks = 0